<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="PreorderSettingList" 
          :extra-items="[
            {
              text: preorderSetting.title ?? '',
            },
            '預購單列表'
          ]"
        />
      </div>
    </div>

    <b-card>
      <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
        <h4 class="col-12 col-xl-4 mb-2 font-weight-bold">
          預購單列表
          <b-button class="mr-1" variant="inverse-dark" @click="showFormUrl">
            <i class="fa fa-link"></i>
          </b-button>
        </h4>
        <b-input-group
          class="col-12 col-xl-8 mb-4"
          style="justify-content: right"
        >
          <AppSingleSelect
            v-if="branchSelectIsEnabled"
            style="width: 50%"
            class="mr-2 mb-2 mb-xl-0"
            v-model="selectedBranch"
            :options="branchFilterOptions"
            @input="handleBranchChange"
            :placeholder="
              preorderSetting.config.branch_select.default_select_text
            "
            :clearable="false"
          >
            <template #first>
              <b-form-select-option :value="null"
                >請選擇訂單櫃點</b-form-select-option
              >
            </template>
          </AppSingleSelect>
          <b-dropdown text="匯出" variant="primary" class="mr-2">
            <b-dropdown-item @click="listExport">清單匯出</b-dropdown-item>
            <b-dropdown-item @click="detailExport">明細匯出</b-dropdown-item>
          </b-dropdown>

          <b-form-input
            class="col-xl-3"
            v-model="query.keyword"
            placeholder="搜尋"
          ></b-form-input>
          <b-input-group-append>
            <b-button @click="handleSearch">
              <i class="fa fa-search"></i>
            </b-button>
          </b-input-group-append>

          <b-button
            v-b-toggle.collapse-1-inner
            variant="link"
            class="flex-shrink-0 ml-0 ml-xl-1"
          >
            進階搜尋<i class="fa fa-chevron-down"></i>
          </b-button>
        </b-input-group>
      </div>
      <b-collapse id="collapse-1-inner" class="mt-2">
        <div class="border p-2">
          <b-form class="">
            <div class="d-flex flex-column flex-xl-row flex-wrap">
              <b-form-group
                label="建立日期"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <DateSearchPicker
                  class="mr-md-2 mr-0"
                  v-model="query"
                  :disabledEndAtDates.sync="disabledEndAtDates"
                  startedPlaceholder="開始時間"
                  endedPlaceholder="結束時間"
                  @input="handleDateChange"
                />
              </b-form-group>
              <b-form-group
                label="訂單狀態"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-form-select
                  class="mr-3"
                  :options="statusOptions"
                  v-model="query.status"
                >
                  <template #first>
                    <b-form-select-option :value="null"
                      >請選擇</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="訂購人名稱"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-form-input
                  v-model="query.name"
                  placeholder="訂購人名稱"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="訂購人手機"
                label-cols-sm="3"
                label-cols-lg="2"
                content-cols-sm
                content-cols-lg="7"
                style="width: 50%"
              >
                <b-form-input
                  v-model="query.mobile"
                  placeholder="訂購人手機"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="flex-column">
              <b-button
                v-b-toggle.accordion-2
                variant="primary"
                class="mb-2 mb-xl-0 mr-2"
                @click="resetSearch"
                ><i class="mdi mdi-restart"></i> 重置條件</b-button
              >
              <b-button
                v-b-toggle.accordion-2
                variant="primary"
                class="mb-2 mb-xl-0"
                @click="handleSearch"
              >
                <i class="fa fa-search"></i> 搜尋
              </b-button>
            </div>
          </b-form>
        </div>
      </b-collapse>
      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-overlay :show="showLoading" rounded="sm">
              <b-table
                striped
                hover
                responsive
                :items="preorders"
                :fields="fields"
              >
                <!-- <template #cell(is_enabled)="data">
                  <b-badge
                    v-if="data.item.is_enabled == true"
                    variant="success"
                  >
                    啟用
                  </b-badge>
                  <b-badge
                    v-if="data.item.is_enabled == false"
                    variant="secondary"
                  >
                    停用
                  </b-badge>
                </template> -->
                <template #cell(customer_name)="data">
                  {{ data.item.customer ? data.item.customer.name : "無" }}
                </template>
                <template v-for="field in visibleDynamicFormFields" v-slot:[`cell(${field.key})`]="data">
                  {{ data.field.value(data.item) }}
                </template>
                <template #cell(preorder_setting_title)="data">
                  {{
                    data.item.preorderSetting
                      ? data.item.preorderSetting.title
                      : "無"
                  }}
                </template>
                <template #cell(branch_name)="data">
                  {{ data.item.branch ? data.item.branch.name : "無" }}
                </template>
                <template #cell(status)="data">
                  {{ displayStatusText(data.item.status) }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    class="mr-1"
                    variant="inverse-warning"
                    :to="{
                      name: 'PreorderDetail',
                      params: {
                        id: preorderSettingId,
                        preorder_id: data.item.id,
                      },
                    }"
                  >
                    <span class="mdi mdi-lead-pencil"></span> 查看訂單
                  </b-button>
                  <b-button
                    class="mr-1"
                    v-if="checkPermission([consts.PREORDER_DELETE])"
                    variant="inverse-danger"
                    @click="deletePreorder(data.item)"
                  >
                    <span class="mdi mdi-delete"></span> 刪除
                  </b-button>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-card-text>
    </b-card>
    <b-modal id="form-url-modal" footer-class="d-flex justify-content-center">
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->

        <h5 class="m-0 align-self-center">{{ preorderSetting.title }}</h5>
        <b-button size="sm" variant="link" class="text-dark" @click="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            style="height: 20px"
          >
            <path
              d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
            />
          </svg>
        </b-button>
      </template>
      <div class="d-flex flex-column align-items-center">
        <h5 class="mb-2">預購網址</h5>
        <b-textarea
          id="form-url"
          v-b-tooltip.click="'已複製'"
          v-model="formUrl"
          @click="copyFormUrl('#form-url')"
        ></b-textarea>
        <div>
          <vue-qr :text="formUrl" ref="qrcode"></vue-qr>
        </div>
      </div>
      <template #modal-footer>
        <div class="modal-button-group">
          <b-button
            variant="primary"
            class="center-button"
            @click="downloadQRCode(preorderSetting.title)"
          >
            下載QRCode
          </b-button>
          <b-button variant="danger" @click="$bvModal.hide('form-url-modal')">
            關閉
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import { format, set } from "date-fns";
import _ from "lodash"
import preorderApi from "@/apis/preorder";
import { mapState, mapGetters } from "vuex";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import generateLiffUrl from "@/mixins/Dashboard/liffUrlHelper";
import { paginationMixin } from "@/mixins/pagination";
import DynamicFormField from "@/models/DynamicFormField.model"
import {
  updateQueryFromRoute,
  updateUrl,
  updateUrlWithoutReload,
} from "@/utils/updateUrl";
import DateSearchPicker from "@/components/Page/Dashboard/DateSearchPicker";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import VueQr from "vue-qr";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { AppSingleSelect, DateSearchPicker, CustomPagination, VueQr, BreadCrumb },
  mixins: [generateLiffUrl, paginationMixin],
  data() {
    const baseFields = [
      { key: "preorder_number", label: "預購單編號", sortable: false },
      { key: "customer_name", label: "會員名稱", sortable: false },
      { key: "preorder_setting_title", label: "活動名稱", sortable: false },
      { key: "total_amount", label: "訂單金額", sortable: false },
      { key: "total_points", label: "訂單點數總計", sortable: false },
      { key: "branch_name", label: "訂單櫃點", sortable: false },
      {
        key: "created_at",
        label: "建立時間",
        sortable: true,
        formatter: (value) => {
          return format(new Date(value), "yyyy-MM-dd HH:mm");
        },
      },
      { key: "status", label: "訂單狀態", sortable: false },
    ];

    const baseQuery = {
      keyword: "",
      per_page: 20,
      start_at: "",
      end_at: "",
      page: 1,
      branch_id: null,
      name: "",
      mobile: "",
      status: null,
    };

    return {
      consts: consts,
      preorderSettingId: null,
      preorderSetting: {},
      preorders: [],
      showLoading: false,
      baseFields: baseFields,
      fields: baseFields,
      totalRows: 0,
      initialized: false,
      query: JSON.parse(JSON.stringify(baseQuery)),
      initQuery: JSON.parse(JSON.stringify(baseQuery)),
      formUrl: null,
      exportDetail: false,
      selectedBranch: null,
    };
  },
  computed: {
    ...mapState("general", ['organization', 'myBranches', 'currentBranch']),
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    disabledEndAtDates() {
      return { to: new Date(this.query.start_at) };
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    branchFilterOptions() {
      return this.myBranches.map((branch) => ({
        value: branch.id, // 確保有正確的 key，例如 id 或其他唯一值
        text: branch.name, // 顯示的名稱
      }));
    },
    statusOptions() {
      if (!this.preorderSetting?.config?.status) {
        return [];
      }

      return (
        this.preorderSetting?.config?.status?.map((status) => ({
          value: status.value,
          text: status.title,
        })) || []
      );
    },
    branchIdFilter() {
      if (!this.branchSelectIsEnabled) {
        return null
      }

      if (this.myBranches.length === 1) {
        return this.myBranches[0].id
      }

      return this.selectedBranch?.value || this.query.branch_id || null
    },
    visibleDynamicFormFields() {
      return DynamicFormField.fromArray(this.preorderSetting?.config?.fields || [])
        .filter(fieldModel => !fieldModel.list_hidden)
        .map(fieldModel => ({
          key: `dynamic_form_data.${fieldModel._id}`,
          label: fieldModel.title,
          value: (preorder) => (preorder.data || []).find(item => item.field_id === fieldModel._id)?.value
        }))
    },
    branchSelectIsEnabled() {
      return _.get(this.preorderSetting, 'config.branch_select.is_enabled', false)
    },
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchPreorders();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);

    if (!this.query.branch_id) {
      this.query.branch_id = this.currentBranch?.id || null
    }
    if (this.query.branch_id) {
      this.selectedBranch = this.branchFilterOptions.find(option => option.value === this.query.branch_id)
    }

    this.fetchPreorders();
    this.initialized = true;
    this.preorderSettingId = this.$route.params.id;
  },
  methods: {
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    async fetchPreorders() {
      try {
        this.showLoading = true;
        let preorderSettingId = this.$route.params.id;

        const settingResponse = await preorderApi.getPreorderSetting(
          preorderSettingId
        )
        this.preorderSetting = settingResponse.data.data
        console.log(this.preorderSetting);

        const response = await preorderApi.getPreorderList(
          preorderSettingId,
          this.params()
        )
        this.preorders = response.data.data
        this.totalRows = response.data.meta.total

        // 如果是預購模式 (null)  => 隱藏訂單金額；隱藏訂單點數統計
        // 如果是金額模式 (money) => 顯示訂單金額；隱藏訂單點數統計
        // 如果是點數模式 (point) => 隱藏訂單金額，顯示訂單點數統計
        const excludeMap = {
          money: ["total_points"],
          point: ["total_amount"],
          default: ["total_amount", "total_points"],
        };
        const mode = this.preorderSetting.charge_mode ?? "default";

        this.baseFields = this.baseFields.filter(
          (field) => !excludeMap[mode].includes(field.key)
        );

        let normalizeProfileFields = await this.normalizeProfileFields();
        // 找到插入的位置
        const insertIndex = this.baseFields.findIndex(
          (field) => field.key === "preorder_setting_title"
        );

        // 創建新的欄位陣列，插入 normalizeProfileFields
        this.fields = [
          ...this.baseFields.slice(0, insertIndex), // 從開頭到插入點之前的欄位
          ...this.visibleDynamicFormFields,
          ...normalizeProfileFields, // 插入 normalizeProfileFields
          ...this.baseFields.slice(insertIndex), // 插入點之後的欄位
        ];

        // 加上 actions 欄位
        this.fields.push({ key: "actions", label: "管理" });
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "讀取列表失敗", "error");
      } finally {
        this.showLoading = false;
      }
    },
    async deletePreorder(preorder) {
      try {
        this.showLoading = true;
        const result = await this.$swal({
          type: "warning",
          title: "您確定要刪除嗎？",
          html: `
            <div class="d-block">
              <div class="my-3">
                <div>刪除訂單：${preorder.preorder_number}</div>
              </div>
            </div>`,
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        });

        if (!result.value) {
          return;
        }

        await preorderApi.deletePreorder(preorder.id);
        this.$swal("刪除成功", "", "success");
        await this.fetchPreorders();
      } catch (error) {
        console.error(error);
        this.$swal("刪除失敗", "", "error");
      } finally {
        this.showLoading = false;
      }
    },
    detailExport() {
      this.exportDetail = true;
      this.handleExport();
    },
    listExport() {
      this.exportDetail = false;
      this.handleExport();
    },
    async handleExport() {
      try {
        this.showLoading = true;
        let preorderSettingId = this.$route.params.id;

        let params = {
          ...this.params(),
          export_detail: this.exportDetail,
        };

        await preorderApi.exportPreorderList(preorderSettingId, params);

        this.$swal({
          title: "成功",
          text: "可至“我的主控台”查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: "確認",
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      } finally {
        this.showLoading = false;
      }
    },
    async normalizeProfileFields() {
      const customerList = this.getModuleConfig(
        "customer",
        "preorder.customer_list"
      );

      const profileMappings = customerList?.[0]?.member_fields ?? [];
      if (profileMappings) {
        return profileMappings.map((mapping) => {
          if (mapping.matched_key.startsWith("extra.")) {
            const key = mapping.matched_key.split("extra.")[1];
            return {
              key: `profiles.${key}`,
              label: mapping.title,
            };
          } else {
            return {
              key: mapping.matched_key,
              label: mapping.title,
            };
          }
        });
      } else {
        return [];
      }
    },
    dateFormatter: (value) => {
      if (!value) return "無";
      return format(new Date(value), "yyyy-MM-dd");
    },
    displayStatusText(statusValue) {
      if (!this.preorderSetting?.config?.status) {
        return "";
      }

      const status = this.preorderSetting.config.status.find(
        (s) => s.value === statusValue
      );

      return status ? status.title : "";
    },
    showFormUrl() {
      this.formUrl = this.generateLiffUrl(`preorder/${this.$route.params.id}`);
      this.$bvModal.show("form-url-modal");
    },
    copyFormUrl(id) {
      const inputText = document.querySelector(id);
      inputText.select();
      document.execCommand("copy");
    },
    handleDateChange(date) {
      const formatDate = (date) => {
        if (!date) return null;
        if (typeof date === "string") return date;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.query.start_at = formatDate(date.start_at);
      this.query.end_at = formatDate(date.end_at);
    },
    handleBranchChange() {
      this.handleSearch();
    },
    handleSearch() {
      if (!this.initialized) return;
      const currentPage = parseInt(this.query.page, 10);

      if (currentPage === 1) {
        updateUrlWithoutReload(this.params(), this.$store, this.$route);
        this.fetchPreorders();
      } else {
        this.query.page = 1;
      }
    },
    resetSearch() {
      this.query = { ...this.initQuery };
    },
    params() {
      return {
        branch_id: this.branchIdFilter || "",
        keyword: this.query.keyword ? this.query.keyword : "",
        name: this.query.name ? this.query.name : "",
        mobile: this.query.mobile ? this.query.mobile : "",
        status: this.query.status ? this.query.status : null,
        page: this.query.page,
        per_page: this.query.per_page,
        ...(this.query.start_at
          ? {
              start_at: format(
                set(new Date(this.query.start_at), {
                  hours: "00",
                  minutes: "00",
                  seconds: "00",
                }),
                "yyyy-MM-dd HH:mm:ss"
              ),
            }
          : {}),
        ...(this.query.end_at
          ? {
              end_at: format(
                set(new Date(this.query.end_at), {
                  hours: "23",
                  minutes: "59",
                  seconds: "59",
                }),
                "yyyy-MM-dd HH:mm:ss"
              ),
            }
          : {}),
      };
    },
    downloadQRCode(filename) {
      const base64QRCodeImage = this.$refs?.qrcode?.$el?.src;
      if (base64QRCodeImage) {
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = base64QRCodeImage;
        temporaryDownloadLink.download = filename
          ? `${filename}.png`
          : "qrcode.png";
        temporaryDownloadLink.style.display = "none";
        document.body.appendChild(temporaryDownloadLink);
        temporaryDownloadLink.click();
      }
    },
  },
};
</script>

<style scoped>
.modal-button-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.modal-button-group > .center-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
